<ng-container *ngIf="data?.length; else emptyTable">
  <div class="data-block" [class.gtin-mode]="gtinMode && ['EWAYBILL', 'TRANSIT'].includes(documentType)" [class.other-doc]="!['EWAYBILL', 'TRANSIT'].includes(documentType) && env.project !== 'BM'">
    <p-table
      [value]="data"
      [scrollable]="true"
      scrollHeight="flex"
      selectionMode="single"
      [class.change-size]="['ME'].includes(env.project)"
      (onRowSelect)="onRowSelect($event)">
        <ng-template pTemplate="header">
            <tr>
              <th>GTIN</th>
              <th i18n>Наименование</th>
              <th i18n>Код ТН ВЭД</th>
              <th i18n>{{ vieField() ? 'Код по таможенному классификатору' : '' }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item" class="single-row">
              <span>
                <td>{{ item.gtin }}</td>
                <td>{{ item.name }}</td>
                <td [class.empty-item]="!item.tnvedCode">{{ item.tnvedCode || "-" }}</td>
                <td *ngIf="vieField()">{{ item.extraCustomsCode || "-" }}</td>
              </span>
              <span class="traceable-row" *ngIf="selectRow?.gtin === item.gtin">
                <td></td>
                <td class="traceable-label">
                  <span i18n>{{ handleCodes(editedTnvedCode ?? item.tnvedCode, item?.extraCustomsCode) ? "Прослеживаемый" : "Непрослеживаемый" }} товар</span>
                </td>
                <td class="editable-trace-block edit-fields">
                  <span i18n>
                    Код ТН ВЭД
                    <span *ngIf="checkTooltipTraceable(editedTnvedCode ?? item.tnvedCode)">
                      <i
                        class="pi pi-exclamation-circle"
                        style="color: #FFA000"
                        tooltipStyleClass="search-item-tooltip"
                        pTooltip="{{ checkTooltipMsg(editedTnvedCode ?? item.tnvedCode) }}"
                        tooltipPosition="bottom">
                      </i>
                    </span>
                  </span>
                  <div class="input-block">
                    <app-number
                      [isDisabled]="!editableFields.tnvedCode"
                      [value]="item.tnvedCode"
                      (valueChange)="editInputComplete($event, 'tnvedCode')"
                      [maxLength]="10">
                    </app-number>
                    <img
                      src="{{ editableFields.tnvedCode ? 'static/icons/NoEdit.svg' : 'static/icons/Edit.svg' }}"
                      (click)="unblockEditable('tnvedCode')"
                      alt=""/>
                  </div>
                </td>
                <td class="editable-trace-block edit-fields" [class.no-editable-btn-view]="!item.extraCustomsCode">
                  <span i18n [class.error-msg]="documentType !== 'EWAYBILL' ? isCustomCodeError : customCode && isCustomCodeError">Код по таможенному классификатору</span>
                  <div class="input-block">
                    <ng-container *ngIf="!findCustomCodes(editedTnvedCode ?? item.tnvedCode)?.length">
                      <app-number
                        [class.code-input]="!item.extraCustomsCode"
                        [isDisabled]="!editableFields.customCode"
                        [value]="customCode"
                        (valueChange)="editInputComplete($event, 'customCode')"
                        [maxLength]="4">
                      </app-number>
                      <img
                        *ngIf="item.extraCustomsCode"
                        src="{{ editableFields.customCode ? 'static/icons/NoEdit.svg' : 'static/icons/Edit.svg' }}"
                        (click)="unblockEditable('customCode')"
                        alt=""/>
                    </ng-container>
                    <ng-container *ngIf="findCustomCodes(editedTnvedCode ?? item.tnvedCode)?.length">
                      <p-dropdown
                        #dropdown
                        [class.traceable-tooltip]="checkTooltipTraceable(editedTnvedCode ?? item.tnvedCode)"
                        [editable]="true"
                        [options]="newCustomCodesSets?.length ? newCustomCodesSets : item.customCodesSets"
                        [style]="{'width':'100%'}"
                        [(ngModel)]="customCode"
                        [maxlength]="4"
                        (onChange)="changeDropdownValue($event)"
                        optionLabel="name"
                      ></p-dropdown>
                    </ng-container>
                  </div>
                </td>
              </span>
            </tr>
        </ng-template>
      <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between">
            <span i18n *ngIf="data?.length > 1">Уточните текст поиска.</span>
          </div>
          <button i18n *ngIf="selectRow?.gtin" type="submit" appSkin="action no-shadow bold bordered" (click)="selectCurrentRow()">Далее</button>
      </ng-template>
    </p-table>
  </div>
</ng-container>
<ng-template #emptyTable>
  <div class="empty-table" [class.gtin-mode]="['EWAYBILL', 'TRANSIT'].includes(documentType) || tabMode">
    <span>
      <ng-container *ngIf="!notFound; else notFoundData">
        <ng-container *ngIf="!gtinMode" i18n>Для поиска введите GTIN или наименование</ng-container>
        <ng-container *ngIf="gtinMode && documentType === 'EWAYBILL'" i18n>Для добавления введите GTIN (о.ц.) и наименование</ng-container>
      </ng-container>
      <ng-template #notFoundData i18n>
        Данные по заданному фильтру не найдены
      </ng-template>
    </span>
  </div>
</ng-template>
